export function deletar(fetch, id) {
  return fetch().delete("/empresa/" + id);
}

export function getAll(fetch) {
  return fetch().get("/empresa");
}

export function getDetalhe(fetch, id) {
  return fetch().get("/empresa/" + id);
}

export function save(fetch, modelo, dados) {
  return fetch().post("", { rota: "/cad/save", modelo, dados });
}

export function post(fetch, loja) {
  return fetch().post("/empresa", loja);
}
